if (!customElements.get('sy-stock-urgency')) {
  customElements.define(
    'sy-stock-urgency',
    class StockUrgency extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          this.update(event.data.html);
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      update(html) {
        const source = html.getElementById(this.id);
        if (!source) return;

        this.innerHTML = source.innerHTML;
      }
    }
  );
}
